<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="0"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      :LogoUrl="require('@/assets/wlogo.svg') "
      :Type="false"
      :ImgUrl="'A01.png'"
      :ImgUrls="'A02.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container5.vue";
export default {
  name: "A01",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "A01.mp4",
        title:
          "Together, we want to help empower you on your treatment journey.",
        list: [
          {
            body:
              "瓦里安為讓患者了解放射治療的原理以及治療期間可能遭遇的情形，並讓正在進行放射治療的病友們安心及提供支持，準備了患者抗癌經驗分享影片。<br><br>希望能夠提供患者及其家屬易於理解且相關的充足資訊，讓每個人對治療有更好的準備並能感到舒適。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;

}
</style>
